import type { EditVehicleExpirationForm } from '@/modules/vehicles/types'
import { subWeeks } from 'date-fns'

/**
 * An expiration always has a date -- unlike a vehicle document, where the date
 * is optional and only exists to notify about. Turning the notification off
 * therefore clears the notification itself (its timestamp and who is
 * responsible for it) and leaves the date alone. The timestamp is stored
 * absolute but entered as "weeks before the expiration date".
 */
export function getVehicleExpirationInput(
  form: EditVehicleExpirationForm,
  hasNotification: boolean
) {
  return {
    description: form.description,
    expirationType: form.expirationType,
    expirationDate: form.expirationDate,
    responsibleUser: hasNotification ? form.responsibleUser : null,
    notificationTime: hasNotification
      ? subWeeks(form.expirationDate, form.notificationTime)
      : null,
  }
}
